// import triggerPopup from "../components/_trigger-popup";
import responsiveVideo from "../components/_responsive-video";
import toggleVideoModal from "../components/_toggle-video-modal";
import timelineInit from "../components/_timeline";

responsiveVideo();

document.querySelector("#video-header").classList.add("loaded");

/* ******************** HORIZONTAL TIMELINE ******************** */
timelineInit();

/* ******************** TRIGGER POPUP ON PAGE LOAD ******************** */
// triggerPopup("#popup");
toggleVideoModal("youtube");
